import React from "react";
import {Menu, MenuItem, ProSidebar, SidebarContent, SidebarFooter, SidebarHeader, SubMenu} from "react-pro-sidebar";
import Helper from "../application/helper";
import {useSelector} from "react-redux";
import CIcon from "@coreui/icons-react";
import {cilHandPointLeft} from '@coreui/icons';
import '../../sass/side_bar.scss';

const SideBar = () => {
    const auth = useSelector(state => state.entities.auth);
    return <>
        <ProSidebar collapsed={false}>
            <SidebarHeader>
                {/**
                 *  You can add a header for the sidebar ex: logo
                 */}
            </SidebarHeader>
            <SidebarContent>
                <Menu iconShape="square">
                    <MenuItem>
                        Dashboard
                        <a href={Helper.route('dashboard')}/>
                    </MenuItem>
                    {auth.is_admin &&
                    <MenuItem>
                        Ledger Balance /Statement
                        <a href={Helper.route('customer-ledger.index')}/>
                    </MenuItem>
                    }
                    <SubMenu open={true} title="Ledger Memo">
                        <MenuItem>
                            Approve /Reject /Edit /Delete
                            <a href={Helper.route('customer-ledger-memo.index')}/>
                        </MenuItem>
                        <MenuItem>
                            Create New Memo
                            <a href={Helper.route('customer-ledger-memo.add')}/>
                        </MenuItem>
                    </SubMenu>
                    <SubMenu open={true} title="Customer Account">
                        <MenuItem>
                            Search /List /Edit/ Deactivate
                            <a href={Helper.route('customer-account.index')}/>
                        </MenuItem>
                        {auth.is_admin &&
                        <MenuItem>
                            Open New Account
                            <a href={Helper.route('customer-account.add')}/>
                        </MenuItem>
                        }
                    </SubMenu>
                </Menu>
            </SidebarContent>
            <SidebarFooter>
                <Menu iconShape="square">
                    <MenuItem onClick={window.toggleSideBar} icon={<CIcon icon={cilHandPointLeft} size={'sm'}/>}>
                        <div className={'float-end'}>
                            Close
                        </div>
                    </MenuItem>
                </Menu>
            </SidebarFooter>
        </ProSidebar>
    </>;
}

export default SideBar;
